export const RESET_STREAM_TO_DEFAULT = 'RESET_STREAM_TO_DEFAULT';
export const LOAD_STREAMS_SINGLE_SUCCESS = 'LOAD_STREAMS_SINGLE_SUCCESS';
export const LOAD_STREAMS_SINGLE_FAILURE = 'LOAD_STREAMS_SINGLE_FAILURE';
export const LOAD_STREAMS_SINGLE_REQUEST = 'LOAD_STREAMS_SINGLE_REQUEST';
